import type { PageProps } from 'gatsby';
import React from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import { TrackerType } from '@models/vital-sign';

import ParameterMain from '@views/Insights/Parameters/Main';

export default function BodyDrilldownPage({ params }: PageProps) {
  const { type } = params;

  return (
    <RoleGuard roles={[RoleName.Practitioner]}>
      <ParameterMain category={TrackerType.Body} code={type} />
    </RoleGuard>
  );
}
